import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { mainListItems } from './list-items.js';
import { Route } from 'react-router-dom';

import UserList from '../Users/user-list.component';
import User from '../Users/user.component';
import SettingList from '../Settings/setting-list.component';
import Setting from '../Settings/setting.component';
import ProductList from '../Products/product-list.component';
import Product from '../Products/product.component';
import BrandList from '../Brands/brand-list.component';
import Brand from '../Brands/brand.component';
import Categories from '../Categories/category-list.component';
import Category from '../Categories/category.component';
import ActivityList from '../Activities/activity-list.component';
import Activity from '../Activities/activity.component';
import SuggestionList from '../Suggestions/suggestion-list.component';
import Suggestion from '../Suggestions/suggestion.component';
import GroupList from '../Groups/group-list.component';
import Group from '../Groups/group.component';
import AttributeList from '../Attributes/attribute-list.component';
import Attribute from '../Attributes/attribute.component';
import ArticleList from '../Posts/article-list.component';
import Article from '../Posts/article.component';
import BannerList from '../Banners/banner-list.component';
import Banner from '../Banners/banner.component';
import SocialNetworkList from '../SocialNetworks/socialnetwork-list.component.js';
import SocialNetwork from '../SocialNetworks/socialnetwork.component';
import OfferList from '../Offers/offer-list.component.js';
import Offer from '../Offers/offer.component';
import OrderList from '../Orders/order-list.component';
import ConversationList from '../Conversations/conversation-list.component';
import Conversation from '../Conversations/conversation.component';
import ProductTypeList from '../ProductTypes/producttype-list.component.js';
import ProductType from '../ProductTypes/producttype.component';

import './menu.styles.css';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
          >
            <MenuIcon />
          </IconButton>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            پنل مدیریت
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronRightIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{mainListItems}</List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {/* User */}
          <Route exact path='/main/users' component={UserList} />
          <Route path='/main/users/byVisitor/:visitorId' component={UserList} />
          <Route exact path='/main/user' component={User} />
          <Route path='/main/user/:userId' component={User} />

          {/* Setting */}
          <Route path='/main/settings' component={SettingList} />
          <Route exact path='/main/setting' component={Setting} />
          {/* <Route path='/main/setting/:key' component={Setting} /> */}
          <Route path='/main/setting/:settingId' component={Setting} />

          {/* Product */}
          <Route path='/main/products' component={ProductList} />
          <Route exact path='/main/product' component={Product} />
          <Route path='/main/product/:productId' component={Product} />

          {/* Brand */}
          <Route path='/main/brands' component={BrandList} />
          <Route exact path='/main/brand' component={Brand} />
          <Route path='/main/brand/:brandId' component={Brand} />

          {/* Subject */}
          <Route path='/main/subjects' component={Categories} />
          <Route exact path='/main/subject' component={Category} />
          <Route path='/main/subject/:subjectId' component={Category} />

          {/* Activity */}
          <Route path='/main/activities' component={ActivityList} />
          <Route exact path='/main/activity' component={Activity} />
          <Route path='/main/activity/:activityId' component={Activity} />

          {/* Suggestion */}
          <Route path='/main/suggestions' component={SuggestionList} />
          <Route path='/main/suggestion/:suggestionId' component={Suggestion} />

          {/* Group */}
          <Route path='/main/Groups' component={GroupList} />
          <Route exact path='/main/group' component={Group} />
          <Route path='/main/group/:groupId' component={Group} />

          {/* Attribute */}
          <Route path='/main/Attributes' component={AttributeList} />
          <Route exact path='/main/Attribute' component={Attribute} />
          <Route path='/main/Attribute/:attributeId' component={Attribute} />

          {/* Post */}
          <Route path='/main/posts' component={ArticleList} />
          <Route exact path='/main/post' component={Article} />
          <Route path='/main/post/:postId' component={Article} />

          {/* Banner */}
          <Route path='/main/banners' component={BannerList} />
          <Route exact path='/main/banner' component={Banner} />
          <Route path='/main/banner/:bannerId' component={Banner} />

          {/* SocialNetwork */}
          <Route path='/main/socialnetworks' component={SocialNetworkList} />
          <Route exact path='/main/socialnetwork' component={SocialNetwork} />
          <Route path='/main/socialnetwork/:socialNetworkId' component={SocialNetwork} />

          {/* Offer */}
          <Route path='/main/offers' component={OfferList} />
          <Route exact path='/main/offer' component={Offer} />
          <Route path='/main/offer/:offerId' component={Offer} />

          {/* Purchase */}
          <Route path='/main/purchases' component={OrderList} />

          {/* Conversation */}
          <Route path='/main/conversations' component={ConversationList} />
          <Route path='/main/conversation/:conversationId' component={Conversation} />

          {/* ProductType */}
          <Route path='/main/productTypes' component={ProductTypeList} />
          <Route exact path='/main/productType' component={ProductType} />
          <Route path='/main/productType/:productTypeId' component={ProductType} />

        </Container>
      </main>
    </div>
  );
}